// Card formats: a single page, a two-page (front/back) card, or the classic folded multi-page card.
import { assemblePages } from './lastPage';

export type CardFormat = 'single' | 'double' | 'folded';

const FORMATS: CardFormat[] = ['single', 'double', 'folded'];

const blankPage = () => [{ images: [], textBoxes: [] }];

/** Missing or unknown formats are treated as folded so existing cards behave as before. */
export const formatOf = (card?: { format?: string }): CardFormat =>
	FORMATS.includes(card?.format as CardFormat) ? (card?.format as CardFormat) : 'folded';

export const maxPagesFor = (format: CardFormat): number =>
	format === 'single' ? 1 : format === 'double' ? 2 : Infinity;

/** A card can only switch to a format that has room for all of its pages. */
export const canSwitchFormat = (pageCount: number, to: CardFormat): boolean => pageCount <= maxPagesFor(to);

/** Lays out pages for the viewer. Single/double ignore the workspace last page. */
export const assembleForFormat = (pages: any[][], lastPage: any | undefined, format?: string): any[][] => {
	const f = formatOf({ format });
	if (f === 'folded') return assemblePages(pages, lastPage);
	const max = maxPagesFor(f);
	const out = pages.slice(0, max);
	while (out.length < max) out.push(blankPage());
	return out;
};

/** i18n key (under `editor.format`) for a page's label, or null when the classic "Page n" label applies. */
export const pageLabelKey = (format: CardFormat, pageIndex: number): string | null => {
	if (format === 'single') return 'card';
	if (format === 'double') return pageIndex === 0 ? 'front' : 'back';
	return null;
};
